import { isString } from '@dimjs/lang';
import { uri } from '@dimjs/utils';
import { toLinkPathWithQuery, urlJoinMulti, valueIsEqual, type TAny } from '@flatbiz/utils';
import { Fragment, isValidElement, Suspense, type ReactElement } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { NotFound } from './compts/404';
import { Bread } from './compts/bread';
import { Loader } from './compts/loader';
import { BreadConfigItem, type BootstrapOptions, type TRouteItemProps } from './types';
import { getIframeMainPurePath, getPurePath } from './utils/utils';
export type AppRouteProps = {
  routeList: TRouteItemProps[];
  hideDefaultBread?: boolean;
  breads?: BreadConfigItem[];
  breadExtendRender?: ReactElement;
  breadTitle?: string | ReactElement;
  layoutMode: BootstrapOptions['layoutMode'];
  hideBreadsPathList: BootstrapOptions['hideBreadsPathList'];
};

export const AppRoutes = (props: AppRouteProps) => {
  const getHideBreadsFlag = () => {
    const target = props.hideBreadsPathList?.find((item) => {
      if (props.layoutMode === 'iframe-tab') {
        return getIframeMainPurePath(item) == getIframeMainPurePath(location.pathname);
      }
      return getPurePath(item) == getPurePath(location.pathname);
    });
    if (target) return true;
    return !!uri.getQueryString('hideBreads');
  };

  const hideBreads = getHideBreadsFlag();

  const routeList = props.routeList;
  const globbingRouteList = routeList.filter((item) => {
    return valueIsEqual(item.path, ['*', '/*', '/*/']);
  });

  return (
    <Fragment>
      <Routes>
        {routeList.map((route, index) => {
          const { path, caseSensitive, element: Element, redirect } = route;
          const isGlobbing = valueIsEqual(path, ['*', '/*', '/*/']);
          if (isString(redirect)) {
            return (
              <Route
                key={index}
                path={path}
                element={<Navigate to={toLinkPathWithQuery(redirect as string)} />}
              />
            );
          }
          if (Element) {
            let elementRender: ReactElement | null = null;
            if (isValidElement(Element)) {
              elementRender = Element;
            } else {
              const CElement = Element as TAny;
              elementRender = (
                <Suspense fallback={<Loader spinning />}>
                  <CElement />
                </Suspense>
              );
            }
            const tempPath = isGlobbing ? '*' : path.endsWith('/*') ? path : urlJoinMulti(path, '*');
            return (
              <Route
                key={index}
                path={tempPath}
                caseSensitive={caseSensitive}
                element={
                  <Fragment>
                    {props.breads && props.hideDefaultBread !== true && !hideBreads ? (
                      <Bread>{props.breadExtendRender}</Bread>
                    ) : null}
                    {elementRender}
                  </Fragment>
                }
              />
            );
          }
          return null;
        })}

        {globbingRouteList.length === 0 ? <Route path="*" element={<NotFound />} /> : null}
      </Routes>
    </Fragment>
  );
};
